module.exports = __webpack_public_path__ + "static/media/rohit.9a7c7750.png";